import AddDelivery from '../components/Delivery/AddDelivery/AddDelivery';
import EditDelivery from '../components/Delivery/EditDelivery/EditDelivery';
import ReceivedDeliveries from '../components/Delivery/ReceivedDeliveries/ReceivedDeliveries';
import HelloWorld from '../components/HelloWorld';
import DeliverySummary from '../components/Delivery/DeliverySummary/DeliverySummary';
import DeliverySummaryPerRawMaterial from '../components/Delivery/DeliverySummary/DeliverySummaryPerRawMaterial';
import Administracja from '../components/Administration/Root';
import CreateCouverture from '../components/Production/CreateCouverture';
import EditCouverture from '../components/Production/EditCouvertureV2';
import DisplayMills from '../components/Production/Mill/DisplayMills';
import DisplayCouverturesOnShelf from '../components/Production/DisplayCouverturesOnShelf';
import Login from '../components/Auth/Login';
import Register from '../components/Auth/Register';
import CouvertureHistory from '../components/Production/CouvertureHistory';
import MixCouvertures from '../components/Production/MixCouveturesFromShelf';
import CreateCompositionForBarrel from '../components/ProductionHall/CreateCompositionForBarrel';
import DisplayBarrels from '../components/ProductionHall/DisplayBarrels';
import CoatingProductHistory from '../components/ProductionHall/CoatingProductHistory';
import EditCoatingProduct from '../components/ProductionHall/EditCoatingProduct';

import VueRouter from 'vue-router';
import store from '../_configuration/store/index';

export const router = new VueRouter({
    routes: [
        {
            path: '/Dostawa',
            name: 'Dostawa surowców',
            component: AddDelivery,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/',
            name: 'Strona Głowna',
            component: HelloWorld,
            meta: {requiredRole: []},
        },
        {
            path: '/PodsumowanieDostawy/:id',
            name: 'Podsumowanie dostawy',
            component: DeliverySummary,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/PodsumowanieDostawyDlaProduktu/:id',
            name: 'Podsumowanie dostawy dla produktu',
            component: DeliverySummaryPerRawMaterial,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/PrzyjeteDostawy',
            name: 'Przyjete dostawy',
            component: ReceivedDeliveries,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Dostawa/:id',
            name: 'Edycja dostawy',
            component: EditDelivery,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Administracja',
            name: 'Administracja',
            component: Administracja,
            meta: {requiredRole: ['Administrator']},
        },
        {
            path: '/StworzKuwerture/:millId',
            name: 'CreateCouverture',
            component: CreateCouverture,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/EdytujKuwerture/:couvertureId',
            name: 'EditCouverture',
            component: EditCouverture,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/HistoriaKuwertury/:couvertureId',
            name: 'CouvertureHistory',
            component: CouvertureHistory,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Mlyny',
            name: 'DisplayMills',
            component: DisplayMills,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/KuwerturyNaPolce',
            name: 'DisplayCouverturesOnShelf',
            component: DisplayCouverturesOnShelf,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Logowanie',
            name: 'Login',
            component: Login,
            meta: {requiredRole: []},
        },
        {
            path: '/Rejestracja',
            name: 'Rejestracja',
            component: Register,
            meta: {requiredRole: []},
        },
        {
            path: '/BrakDostepu',
            name: 'NoAccess',
            component: () => import('../components/Auth/NoAccess.vue'),
            meta: {requiredRole: []},
        },
        {
            path: '/WymieszajKuwertury/:millId',
            name: 'MixCouvertures',
            component: MixCouvertures,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/OblewajProdukt/:barrelId',
            name: 'CreateCompositionForBarrel',
            component: CreateCompositionForBarrel,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Bebny',
            name: 'DisplayBarrels',
            component: DisplayBarrels,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/HistoriaOblewania/:coatingProductInstanceId',
            name: 'CoatingProductHistory',
            component: CoatingProductHistory,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/OblewaneProdukt/:Type',
            name: 'DisplayCoatingProducts',
            component:()=> import('../components/ProductionHall/DisplayCoatingProducts.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/EdytujKompozycje/:barrelId',
            name: 'EditCoatingProduct',
            component: EditCoatingProduct,
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/nalepkiDostawa/:id',
            name: 'nalepkiDostawa',
            component: () => import('../components/Delivery/DeliverySummary/DeliveryStickers.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/AktualnyStanMagazynowy',
            name: 'CurrentStockLevels',
            component: () => import('../components/Delivery/ReceivedDeliveries/CurrentStock/CurrentStockLevels.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/TworzenieCzekolady/:ChocolateSharpenerId',
            name: 'CreateClearChocolate',
            component: () => import('../components/ProductionHall/ClearChocolate/CreateClearChocolate'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Temperowki/',
            name: 'chocolateSharpeners',
            component: () => import('../components/ProductionHall/ChocolateSharpener/ChocolateSharpeners'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/DodajKuwertureDoTemperowki/:chocolateSharpenerId',
            name: 'CreateComposition',
            component: () => import('../components/ProductionHall/ChocolateSharpener/AssignCouvertureToChocolateSharpener'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/EdycjaCzystejCzekolady/:machineId/:coatingProductId',
            name: 'EdycjaCzystejCzekolady',
            component: () => import('../components/ProductionHall/ClearChocolate/EditClearChocolate'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/TworzenieCzekoladyZProduktem/:ChocolateSharpenerId',
            name: 'CreateClearChocolateWithIngredient',
            component: () => import('../components/ProductionHall/ChocolateWithCoatingProduct/CreateChocolateWithIngredient'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/TworzenieOblewanegoProduktu-Temperowka/:ChocolateSharpenerId',
            name: 'CreateClearChocolateWithIngredient',
            component: () => import('../components/ProductionHall/CoatingProduct/CreateCoatingProductAtChocolateSharpener'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/EdycjaCzekoladyZProduktem/:machineId/:coatingProductId',
            name: 'EditClearChocolateWithIngredient',
            component: () => import('../components/ProductionHall/ChocolateWithCoatingProduct/EditChocolateWithIngredient'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/TworzenieProduktuZHerbatnikiem/:ChocolateSharpenerId',
            name: 'CreateCoatingProductWithBiscuit',
            component: () => import('../components/ProductionHall/CoatingProductWithBiscuit/CreateCoatingProductWithBiscuit'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/TworzenieKremu/:ChocolateSharpenerId',
            name: 'CreateCream',
            component: () => import('../components/ProductionHall/Cream/CreateCream'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/EdycjaKremu/:machineId/:coatingProductId',
            name: 'EditCream',
            component: () => import('../components/ProductionHall/Cream/EditCream'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Pakowanie/Zapakuj/:recipeType/:productId',
            name: 'PackProduct',
            component: () => import('../components/Packing/PackProduct'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Magazyn',
            name: 'Warehouse',
            component: () => import('../components/warehouse/Warehouse'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Pakowanie/UtrataProduktu/:packedProductId',
            name: 'PackedProductLoss',
            component: () => import('../components/warehouse/Warehouse.ProductLoss'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Pakowanie/Przepakowanie/:packedProductId',
            name: 'RepackProduct',
            component: () => import('../components/Packing/RepackRoot'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Pakowanie/TransferProduktow/:packedProductId',
            name: 'TransferProductBetweenWarehouse',
            component: () => import('../components/warehouse/Warehouse.TransferProductBetweenWarehouse'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Magazyn/Raport',
            name: 'WarehouseDailyReport',
            component: () => import('../components/warehouse/Warehouse.DailyReport'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/WydanieTowaru',
            name: 'CreateProductConsumption',
            component: () => import('../components/ProductConsumption/CreateProductConsumption.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/WydanieTowaru/:productConsumptionId',
            name: 'EditProductConsumption',
            component: () => import('../components/ProductConsumption/EditProductConsumption.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/WydaneTowary',
            name: 'DisplayProductConsumptions',
            component: () => import('../components/ProductConsumption/DisplayProductConsumptions.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/ZamowieniaDoZapakowania',
            name: 'ManagePackingProductList',
            component: () => import('../components/Orders/ManageOrder.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/ZamowieniaDoZapakowania/:orderId',
            name: 'ManagePackingProductList',
            component: () => import('../components/Orders/ManageOrder.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/ListaZamowien',
            name: 'DisplayOrdersConsumptions',
            component: () => import('../components/Orders/DisplayOrdersLists.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/ZamowieniaPoProdukcie/:productId',
            name: 'DisplayOrdersConsumptions',
            component: () => import('../components/ProductConsumption/ProductConsumptionPerProduct.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
        {
            path: '/Raport/:coatingProductId',
            name: 'CoatingProductRaport',
            component: () => import('../components/Report/ReportDoc.vue'),
            meta: {requiredRole: ['Użytkownik', 'Administrator']},
        },
    ],
});


router.beforeEach((to, from, next) => {
    if (to.meta.requiredRole &&  to.meta.requiredRole.length > 0) {
        store.commit('isLoggedIn');
        if (store.state.token) {
            //Sprawdzanie czy ma Uprawnienia
            var userRoles = store.getters.roles;
            if (to.meta.requiredRole.some(r => userRoles.includes(r))) {
                next();
                return;
            } else {
                next('/BrakDostepu');
                return;
            }
        }
        store.commit('logout');
        next('/Logowanie');
    } else {
        next();
    }
});
